import { Account } from "@/core/customers/entities/Accounts";
import GetAccountsUseCase from "@/core/customers/useCases/GetAccountsUseCase/GetAccountsUseCase";
import type { FicheClient360State, FicheClient360StoreDeps } from "../types";
import { createFetchAction } from "../helpers";

export function createAccountsSlice(
  deps: FicheClient360StoreDeps,
  set: (partial: Partial<FicheClient360State>) => void,
): Partial<FicheClient360State> {
  const getAccountsUseCase = new GetAccountsUseCase(deps.accountsRepository);

  return {
    fetchAccounts: createFetchAction<Account[]>(
      set,
      "accountsLoading",
      "accountsError",
      "accounts",
      (businessKey) => getAccountsUseCase.execute(businessKey),
      "Erreur lors du chargement des comptes :",
      () => [],
    ),
  };
}
